import { render, staticRenderFns } from "./tableND.vue?vue&type=template&id=17df4131&scoped=true&"
import script from "./tableND.vue?vue&type=script&lang=ts&"
export * from "./tableND.vue?vue&type=script&lang=ts&"
import style0 from "./tableND.vue?vue&type=style&index=0&id=17df4131&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df4131",
  null
  
)

export default component.exports